import './App.css';

import Loader from "./components/Loader";
function App() {
    return (
        <div className="App">
            <Loader />
        </div>
    );
}
export default App;
